import { render } from "./RequirementDialog.vue?vue&type=template&id=f2e106c6&scoped=true"
import script from "./RequirementDialog.vue?vue&type=script&lang=js"
export * from "./RequirementDialog.vue?vue&type=script&lang=js"

import "./RequirementDialog.vue?vue&type=style&index=0&id=f2e106c6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e106c6"]])

export default __exports__